import axios from "axios";

export const toggleRedeemPoints = async (redeem: boolean): Promise<void> => {
    await axios.post(
        `/packages/cart/toggleRedeemPoints/?redeem=${redeem}`,
        {},
        {
            headers: { 'Content-Type': 'application/json' }
        }
    );
};
